import { fromJS, Map } from 'immutable';
import { SET_MAP_DATA } from '../constants/map';

const initialState = Map();

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_MAP_DATA:
      return state.merge(fromJS(action.payload));
    default:
      return state;
  }
}
